/**
 * URL do site 123milhas. Em dev multi-tenant o backend informa a URL do tenant
 * via <meta name="host-123milhas-url">; sem ela, usa a do build.
 */
export function getHost123milhasUrl() {
    var _a;
    var tenantUrl = (_a = document
        .querySelector('meta[name="host-123milhas-url"]')) === null || _a === void 0 ? void 0 : _a.getAttribute("content");
    return tenantUrl || process.env.MIX_HOST_123MILHAS_URL;
}
